import { Skeleton } from '@openedx/paragon';
import { OnApproveData } from '@paypal/paypal-js';
import { PayPalButtons, usePayPalScriptReducer } from '@paypal/react-paypal-js';
import { getIsCTADisabled, useAppSelector } from 'store';
import { ElementClicked, elementEvents, ElementType } from 'utils/eventing';
import { useCart, usePayPalOptions } from 'frontastic/hooks';

export const PayPalButton = () => {
  const { data } = useCart();
  const { createOrder, onApprove, onCancel, onError } = usePayPalOptions();
  const [{ isPending: isPayPalButtonLoading }] = usePayPalScriptReducer();
  const isCTADisabled = useAppSelector(getIsCTADisabled);

  const paypalTagularElement: ElementClicked['webElement'] = {
    elementType: ElementType.Button,
    name: 'paypal-cta',
    text: 'PayPal',
    htmlId: 'paypal-click',
    location: 'checkout',
  };

  const { elementClicked: paypalElementClicked } = elementEvents({
    webElement: paypalTagularElement,
  });

  const handlePaypalElementClicked = () => paypalElementClicked();

  const handleOnApprove = async (approvalData: OnApproveData) => {
    await onApprove(approvalData);
  };

  if (isPayPalButtonLoading) {
    return <Skeleton className="pb-2.5 pt-3" />;
  }

  return (
    <PayPalButtons
      disabled={isCTADisabled}
      style={{
        height: 44,
        shape: 'sharp',
      }}
      createOrder={createOrder}
      onApprove={handleOnApprove}
      onCancel={onCancel}
      onClick={handlePaypalElementClicked}
      onError={onError}
      forceReRender={[data?.cartId, data?.cartVersion]}
    />
  );
};
